import NoFilterResultsIconRaw from "../../../img/trade-history/no-filter-results.svg?react";
import { Button } from "../../../components/general/Button/Button";

import styled from "@emotion/styled";
import { Spacer } from "../../../components/general/Spacer/Spacer";
import { GlobalStore } from "store/global/GlobalStore";
import { useIsMobile } from "hooks/useDeviceType";
import { Body, buttonCss, Title } from ".";

interface NoFilterResultDisplayProps {
  clearAllFilters: () => void;
}

export const NoFilterResultDisplay = ({ clearAllFilters }: NoFilterResultDisplayProps) => {
  const theme = GlobalStore.useState(s => s.theme);
  const isMobile = useIsMobile();
  return (
    <Container>
      <NoFilterResultsIcon />
      <Spacer height="22px" />
      <Title>Nothing to show here</Title>
      <Body>
        Hmm we can’t find anything that matches this criteria. Try adjusting your filters.
      </Body>
      <Button
        buttonType={"primary"}
        onClick={clearAllFilters}
        height={40}
        text="Clear filters"
        buttonCss={buttonCss(theme, isMobile)}
      />
    </Container>
  );
};

// Sub-components

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 300px;
`;

const NoFilterResultsIcon = styled(NoFilterResultsIconRaw)`
  margin: auto;
`;
